import React from "react";

/**
 * Top of the left flow panel: progress bar (33/66/100%) and "Zurück" (hidden on step 1).
 * The "Du hast bereits einen Account? Login" prompt lives top-right over the social-proof
 * panel (rendered in RegistrationScreen), not here.
 */
const RegistrationHeader = ({ progress, canGoBack, onBack }) => {
    return (
        <div className="registration-header">
            <div
                className="registration-header__progress"
                data-cy="registration-progress"
                role="progressbar"
                aria-label="Registrierungsfortschritt"
                aria-valuenow={progress}
                aria-valuemin={0}
                aria-valuemax={100}
            >
                <div className="registration-header__progress-bar" style={{ width: `${progress}%` }} />
            </div>

            <div className="registration-header__bar">
                {canGoBack && (
                    <button
                        type="button"
                        className="registration-header__back"
                        onClick={onBack}
                        data-cy="registration-back-button"
                    >
                        ← Zurück
                    </button>
                )}
            </div>
        </div>
    );
};

export default RegistrationHeader;
